<template>
  <div
    class="flex flex-col gap-[24px] w-full h-fit bg-white border border-grays-400 rounded py-[22px] pl-[16px] pr-[36px]"
  >
    <!-- Intro/Edit -->
    <div class="flex flex-row w-full h-fit items-center">
      <h3 class="flex-1 text-xl font-medium text-primary-700 min-h-[36px]">
        פרטי החשבון המשפחתי
      </h3>
      <button-secondary v-if="!editMode" @click="toggleEditMode">
        <span class="material-symbols-rounded text-lg">edit</span>
        לשנות סיסמא
      </button-secondary>
    </div>
    <!-- Edit fields -->
    <div class="xl:flex flex-row w-full gap-[20px]">
      <div class="flex flex-col gap-[4px] xl:w-[300px]">
        <div class="flex flex-col">
          <span class="text-grays-700 text-sm">מייל</span>
          <!-- <span v-if="email" class="mt-3 text-grays-900 text-base">{{ email }}</span>
          <span v-else class="mt-3 text-red-500 text-base">יש להגדיר אימייל במערכת</span> -->
          <span class="mt-3 text-grays-900 text-base">{{ email}}</span>
        </div>
      </div>
      <div class="lg:flex gap-5">
        <div>
          <input-password
            :id="'firstPassword'"
            v-model="password"
            :disabled="!editMode"
            :label="'סיסמא'"
            :passwordVisibility="passwordVisibility"
            :placeholder="'••••••••'"
          >
          </input-password>
          <password-checks
            v-if="editMode"
            :id="'secondPassword'"
            :password="password"
            :context="{ email }"
            :shouldShowError="true"
            @update:valid="passwordValid = $event"
          />
        </div>

        <div v-if="editMode">
          <input-password
            v-model="repeatPassword"
            :disabled="!editMode"
            :label="'אישור סיסמא חדשה'"
            :passwordVisibility="repeatPasswordVisibility"
            :placeholder="'••••••••'"
          >
          </input-password>
          <div
            v-if="password !== repeatPassword && editMode"
            class="text-error text-sm"
          >
            Password must be the same
            <span class="material-symbols-rounded text-sm">error</span>
          </div>
        </div>
      </div>
    </div>
    <error-block v-if="requestError" :error-message="errorMessage" />
    <!-- Save chnages -->
    <div v-if="editMode" class="flex flex-row-reverse items-end">
      <button-secondary
        :disabled="
          v$.$error ||
          isLoading ||
          !(passwordValid && password === repeatPassword)
        "
        @click="handleSave"
      >
        {{ isLoading ? "Loading" : "לעדכן פרטים" }}
      </button-secondary>
      <button-text @click="toggleEditMode">בטל</button-text>
    </div>
  </div>
</template>

<script>
import useValidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { userValidation } from "@/validation/User";
import { mapGetters, mapMutations } from "vuex";
import ButtonIcon from "@/components/Global/ButtonIcon.vue";
import InputDefault from "@/components/Global/InputDefault.vue";
import InputPassword from "@/components/Global/InputPassword.vue";
import ErrorBlock from "@/components/Global/ErrorBlock.vue";
import ButtonSecondary from "@/components/Global/ButtonSecondary.vue";
import PasswordChecks from "@/components/Registration/PasswordChecks.vue";
import axiosInstance from "@/helpers/axios";
import ButtonText from "@/components/Global/ButtonText.vue";

export default {
  name: "account-details-card",
  components: {
    ButtonText,
    PasswordChecks,
    ButtonSecondary,
    ErrorBlock,
    InputPassword,
    InputDefault,
    ButtonIcon,
  },
  props: {
    profileData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      v$: useValidate(),
      editMode: false,
      password: "",
      passwordValid: false,
      repeatPassword: "",
      passwordVisibility: false,
      repeatPasswordVisibility: false,
      isLoading: false,
      requestError: false,
      emailSend: false,
      errorMessage: undefined,
    };
  },
  validations() {
    return {
      email: userValidation.email,
      password: {
        required,
      },
    };
  },
  // mounted() {
  //   if (!this.email) {
  //     this.toggleEditMode()
  //   }
  // },
  methods: {
    ...mapMutations({
      setEmail: "user/setEmail",
    }),
    toggleEditMode() {
      this.editMode = !this.editMode;
      if (!this.editMode) {
        this.password = "";
      }
    },
    togglePasswordVisibility() {
      this.passwordVisibility = !this.passwordVisibility;
    },
    toggleRepeatPasswordVisibility() {
      this.repeatPasswordVisibility = !this.repeatPasswordVisibility;
    },
    async handleSave() {
      if (this.password) {
        this.v$.$validate();
      }
      if (
        !this.v$.$error &&
        this.passwordValid &&
        this.password === this.repeatPassword
      ) {
        this.isLoading = true;
        try {
          const dataForm = {};
          if (this.password) {
            dataForm.password = this.password;
          }
          const { data } = await axiosInstance.put("/clients", dataForm);
          // A new password signs other devices out; this one gets a fresh token.
          if (data?.access_token) {
            localStorage.setItem("token", data.access_token);
          }
          this.emailSend = true;
          // Reset request error & toggle edit btn.
          this.errorMessage = undefined;
          this.requestError = false;
          this.password = "";
          this.repeatPassword = "";
          this.toggleEditMode();
        } catch (e) {
          console.error(e);
          this.errorMessage = e.response.data.message || undefined;
          this.requestError = true;
        } finally {
          this.isLoading = false;
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      email: "user/getEmail",
    }),
  },
  watch: {
    profileData: {
      deep: true,
      handler(updatedData) {
        this.setEmail(updatedData.email);
      },
    },
  },
};
</script>

<style>
</style>